import React from 'react'
import TooltipWrapper from '../tooltips/TooltipWrapper'
import Step2TooltipRevenueCard from '../tooltips/Step2TooltipRevenueCard'
import JustificatifeDomicile from '../tooltips/JustificatifeDomicile'

const DocumentTooltipBuilder = ({
  type,
}: {
  type: string | null | undefined
}) => {
  switch (type) {
    case 'revenueDocs':
      return (
        <TooltipWrapper className="mb0" textPosition="textLeft">
          <Step2TooltipRevenueCard />
        </TooltipWrapper>
      )
    case 'justificatifHeberge':
      return (
        <TooltipWrapper className="mb0" textPosition="textLeft">
          <JustificatifeDomicile />
        </TooltipWrapper>
      )
    case 'justificatifDomicile':
      return (
        <TooltipWrapper className="mb0" textPosition="textLeft">
          <JustificatifeDomicile />
        </TooltipWrapper>
      )
    default:
      return <></>
  }
}

export default DocumentTooltipBuilder
